module.exports = __webpack_public_path__ + "img/icon-model-segmentation_color.b8cf0a14.svg";